// extracted by mini-css-extract-plugin
export default {"contact_section":"contact_contact_section__++fKU","data_container":"contact_data_container__tNA7V","data_item":"contact_data_item__NXP-Y","not_empty":"contact_not_empty__DZtON"};